import React, { useEffect, useState } from "react";

import Story from "./Story";
import "./index.css";

const LivePage = () => {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimation(true);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`story-view ${animation ? "active" : ""}`}>
      <Story />
    </div>
  );
};

export default LivePage;
